// status-webapp/src/hooks/useRunnerHealth.ts
import { useEffect, useState } from "react";

export function useRunnerHealth(intervalMs = 10000): { online: boolean } {
  const [online, setOnline] = useState(true);
  useEffect(() => {
    let cancelled = false;
    async function check() {
      try {
        const r = await fetch("/api/health", { cache: "no-store" });
        if (!cancelled) setOnline(r.ok);
      } catch {
        if (!cancelled) setOnline(false);
      }
    }
    check();
    const t = setInterval(check, intervalMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [intervalMs]);
  return { online };
}
